import type { OrgEntitlementsResponse, PlanCatalogueResponse } from "@/interfaces/entitlements";
import { apiClient } from "@/lib/apiClient";

/**
 * Entitlement reads. Both endpoints return RESOLVED values — `max_recipients: 2000`, never
 * `plan: "pro"` plus rules to evaluate — so nothing here or downstream of it decides a plan.
 */

/**
 * One organization's entitlement matrix. Keyed on the ORGANIZATION, not the caller: a plan
 * belongs to an organization, and "the caller's own plan" is the wrong answer on every
 * GFG-facing surface. Members read their own org; reading another needs ORGANIZATION view.
 */
export async function fetchOrgEntitlements(organizationId: number) {
  const { data } = await apiClient.get<OrgEntitlementsResponse>(
    `/organizations/${organizationId}/entitlements`,
  );
  return data;
}

/** The catalogue — every public plan's limits and the copy that sells it. */
export async function fetchPlans(): Promise<PlanCatalogueResponse> {
  const { data } = await apiClient.get<PlanCatalogueResponse>("/plans");
  return data;
}
